module.exports = __webpack_public_path__ + "img/message-avatar-four.a5e6668d.svg";